import Icon from '@ant-design/icons';

import { useTranslation } from '@/i18n/client';
import { EVENT } from '@/utils/event';

import styles from '../../index.less';
import { IconMap, MenuItem, MenuTNameMap } from '../constant';

interface IProps {}

const SubscriptionItem: React.FC<IProps> = () => {
  const { t } = useTranslation();

  return (
    <div
      className={styles.menuItem}
      onClick={() => {
        dispatchEvent(new Event(EVENT.UNFOLD_SUBSCRIPTION));
      }}
    >
      <Icon className={styles.icon} component={IconMap[MenuItem.Subscription]} />
      <span className={styles.text}>{t(MenuTNameMap[MenuItem.Subscription])}</span>
    </div>
  );
};

export default SubscriptionItem;
